<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Name
              </th>
            </tr>
            </thead>
            <tbody v-if="templates">
            <tr
                class="hover:bg-gray-100"
                v-for="(template, templateIdx) in templates"
                :key="template.id"
                :class="templateIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                <td
                  @click="() => handleEdit(template)"
                  class="relative px-6 cursor-pointer py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  <div v-if="!template.valid" class="absolute inset-y1 left-0 pl-3 flex items-center">
                    <Tooltip v-bind:msg="validationMessage(template)">
                      <ExclamationIcon  class="h-5 w-5 text-yellow-400" aria-hidden="true" />
                    </Tooltip>
                  </div>
                  <div class="relative inset-y1 left-0 pl-3 flex items-center pointer-events-none">
                    {{ template.name }}
                  </div>
                </td>


                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <button @click.prevent="() => { activeTemplate = template; dangerModalIsOpen = true }" class="text-red-500 hover:text-red-900">Delete</button>

                </td>


            </tr>
            </tbody>
          </table>

          <update-template-panel v-if="activeTemplate" :template-id="activeTemplate.id" />
        </div>
      </div>
    </div>
    <danger-modal
        :open="dangerModalIsOpen"
        title="Are you sure you want to destroy this template?"
        content="This action CANNOT be undone."
        cancel-button-text="Cancel"
        action-button-text="Destroy"
        v-on:modal:cancel="() => { dangerModalIsOpen = false; activeTemplate = null }"
        v-on:modal:perform="handleDelete" />
  </div>
</template>

<script>
import UpdateTemplatePanel from "@/components/ClientDetails/SlideoutPanels/UpdateTemplatePanel";
import DangerModal from "@/components/Functional/Modal/DangerModal";
import { ExclamationIcon } from '@heroicons/vue/outline'
import Tooltip from "@/components/Functional/Tooltip"

export default {
  name: "TemplatesTable",
  components: {DangerModal, UpdateTemplatePanel, ExclamationIcon, Tooltip},
  props: [
      "clientId",
      "editCallback"
  ],
  data() {
    return {
      activeTemplate: null,
      dangerModalIsOpen: false,
    }
  },
  methods: {
    async handleDelete() {
      this.$store.dispatch('showLoadingSpinner')

      try {
        await this.$store.dispatch('deleteTemplate', this.activeTemplate)
        this.$store.dispatch('createAlert', {
          type: 'success',
          message: 'Template Successfully Deleted'
        })
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
        this.dangerModalIsOpen = false
        this.activeTemplate = null
        this.$store.dispatch('hideLoadingSpinner')
      }
      this.dangerModalIsOpen = false
      this.activeTemplate = null
      this.$store.dispatch('hideLoadingSpinner')

    },
    async handleEdit(template) {
      this.$store.dispatch('showLoadingSpinner')

      this.activeTemplate = template
      try {
        await this.$store.dispatch('getTemplate', template.id)

      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      try {
        await this.$store.dispatch('openUpdateTemplatePanel')
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('hideLoadingSpinner')

    },
    validationMessage(template) {
      if (template.validationMessages) {
        return template.validationMessages.join("\n")
      } else {
        return ''
      }
    },
  },
  computed: {
    templates() {
      return this.$store.getters.getTemplates;
    }
  },
}
</script>

<style scoped>

</style>
